<template>
    <div class="mb-5">
        <!-- МОДАЛКА СОЗДАНИЯ/РЕДАКТИРОВАНИЯ НОВОСТИ -->
        <vs-popup class="news_modal" :title="popupTitle" :active.sync="newsPopup">
            <form v-if="newsPopup">
                <div class="vx-row w-full mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" v-validate="'required'" name="title" :label="$t('title')"
                            v-model="news.title" />
                        <span class="text-danger text-sm"
                            v-show="errors.has('title')">{{ $t('validation_required') }}</span>
                    </div>
                </div>
                <div class="vx-col relative overflow-scroll" style="height:400px">
                    <div class="vx-row w-full mb-6">
                        <div class="vx-col w-full">
                            <quill-editor ref="contentEditor" :options="editorOption" v-validate="'required'"
                                name="content" v-model="news.content">
                                <div id="toolbar" slot="toolbar">
                                    <!-- Add a bold button -->
                                    <button class="ql-bold" title="Bold">Bold</button>
                                    <button class="ql-italic" title="Italic">Italic</button>
                                    <button class="ql-underline" title="Underline">underline</button>
                                    <button class="ql-strike" title="Strikethrough">strike</button>
                                    <button class="ql-blockquote" title="Quote"></button>
                                    <button class="ql-code-block" title="Code"></button>
                                    <button class="ql-header" value="1" title="Title 1"></button>
                                    <button class="ql-header" value="2" title="Title 2"></button>

                                    <!--Add list -->
                                    <button class="ql-list" value="ordered" title="Ordered list"></button>
                                    <button class="ql-list" value="bullet" title="Unordered List"></button>

                                    <!-- Add font size dropdown -->
                                    <select class="ql-header" title="Paragraph format">
                                        <option selected>paragraph</option>
                                        <option value="1">Heading 1</option>
                                        <option value="2">Title 2</option>
                                        <option value="3">Heading 3</option>
                                        <option value="4">Heading 4</option>
                                        <option value="5">Title 5</option>
                                        <option value="6">Title 6</option>
                                    </select>
                                    <select class="ql-size" title="font size">
                                        <option value="10px">10px</option>
                                        <option value="12px">12px</option>
                                        <option value="14px">14px</option>
                                        <option value="16px" selected>16px</option>
                                        <option value="18px">18px</option>
                                        <option value="20px">20px</option>
                                    </select>

                                    <!-- Add subscript and superscript buttons -->
                                    <select class="ql-color" value="color" title="font color"></select>
                                    <select class="ql-background" value="background" title="background color"></select>
                                    <select class="ql-align" value="align" title="Align"></select>
                                    <button class="ql-clean" title="reduction"></button>
                                    <button class="ql-link" title="Hyperlinks"></button>
                                    <button class="ql-video" title="Video"></button>

                                    <!-- Custom Buttons -->
                                    <button id="button_image" @click.prevent="filesModalHandler('image')" title="image">
                                        <vs-icon icon="add_photo_alternate"></vs-icon>
                                    </button>
                                    <button id="button_video" @click.prevent="filesModalHandler('video')" title="Video">
                                        <vs-icon icon="videocam"></vs-icon>
                                    </button>
                                    <button id="button_audio" @click.prevent="filesModalHandler('audio')" title="Audio">
                                        <vs-icon icon="audiotrack"></vs-icon>
                                    </button>
                                    <button id="button_doc" @click.prevent="filesModalHandler('doc')" title="Doc">
                                        <vs-icon icon="content_paste"></vs-icon>
                                    </button>

                                    <!-- Edit HTML Button -->
                                    <button id="button_html_edit" title="Edit HTML" class="ql-edit-html">
                                        <vs-icon icon="code"></vs-icon>
                                    </button>
                                </div>
                            </quill-editor>
                            <span class="text-danger text-sm"
                                v-show="errors.has('content')">{{ $t('validation_required') }}</span>
                        </div>
                    </div>

                    <!-- СДЕЛАТЬ НОВОСТЬ СРОЧНОЙ -->
                    <div class="vx-row w-full mb-6">
                        <div class="vx-col w-full">
                            <vs-checkbox v-model="news.is_important">{{$t('breaking_news')}}</vs-checkbox>
                        </div>
                    </div>

                    <!-- Загрузчик главного изображения новости -->
                    <div class="vx-row w-full mb-6">
                        <div class="vx-col w-full">
                            <label class="vs-input--label">{{$t('news_title_photo')}}</label>
                            <vs-upload class="zindex" :action="'common/upload/'" @on-success="setFiles"
                                @prev-delete="removeFile" ref="imageUpload" single-upload :firstFiles="files" :limit="1"
                                automatic :max-size="uploadSettings.max_file_size" :fileName="'path'" />
                        </div>
                    </div>

                    <!-- НАСТРОЙКИ ВИДИМОСТИ ФОРМЫ -->
                    <div class="collapse_margin">
                        <vs-collapse class="mb-6" type="border">
                            <vs-collapse-item>
                                <div slot="header">
                                    {{$t('visibility_settings')}}
                                </div>
                                <div class="vx-row w-full">
                                    <!-- Селекты настроек видимости в цикле -->
                                    <div class="vx-col vs-xs-12 vs-sm-4 vs-lg-4 mb-2"
                                        v-for="(select, name, index) in selectActive" :key="`sel_${index}`">
                                        <label class="vs-input--label">{{$t(name)}}</label>

                                        <multiselect v-model="selectActive[name]" placeholder="" :id="name"
                                            open-direction="top" :name="name" :options="dynamicOptions(name)"
                                            :multiple="(name !== 'specialist') ? true : false"
                                            :track-by="(name !== 'courses') ? 'uid' : ''"
                                            :loading="isLoading[name]" deselectLabel="" selectLabel=""
                                            :custom-label="multiselectLabel" :clear-on-select="false"
                                            :close-on-select="false" @open="openSelect(name)"
                                            @select="multiselectHander" @remove="multiselectHander" :max-height="250"
                                            :show-no-results="false" :hide-selected="true">
                                            <template
                                                v-if="name !== 'courses' && name !== 'roles' && name !== 'specialist'"
                                                slot="option" slot-scope="props">{{ props.option.name }}</template>
                                            <template
                                                v-if="name !== 'courses' && name !== 'roles' && name !== 'specialist'"
                                                slot="tag" slot-scope="{ option, remove }">
                                                <span class="multiselect__tag">
                                                    <span>{{ option.name }}</span>
                                                    <i @click="remove(option)" class="multiselect__tag-icon"></i>
                                                </span>
                                            </template>
                                            <template v-if="name === 'specialist'" slot="option" slot-scope="props">
                                                {{props.option.specialist_type.name}}
                                            </template>

                                            <div slot="noOptions">{{$t('no_data_text')}}</div>
                                        </multiselect>
                                    </div>
                                </div>
                            </vs-collapse-item>
                        </vs-collapse>
                    </div>


                </div>

                <div class="vx-row w-full mb-6">
                    <div class="vx-col">
                        <vs-button class="mr-2" color="primary" @click="formSubmit({is_close_modal:false})" type="filled">{{$t('add')}}
                        </vs-button>
                        <vs-button class="mr-2" color="primary" @click="formSubmit({is_close_modal:true})" type="filled">{{$t('save_and_add')}}
                        </vs-button>
                        <vs-button color="primary" @click="formClear()" type="border">{{$t('clear')}}</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>

        <!-- Модалка удаление новости -->
        <vs-popup class="news_delete_modal" :title="$t('remove')" :active.sync="deletePopup">
            <div class="flex items-center justify-center">
                <vs-button @click="deleteNews()" class="mr-2" color="danger" type="filled">{{$t('remove')}}</vs-button>
                <vs-button color="primary" @click="deletePopup = false" type="border">{{$t('close')}}</vs-button>
            </div>
        </vs-popup>

        <!-- Окно загрузки файлов в текстовый редактор -->
        <vs-popup class="upload_popup" :button-close-hidden="uploadPopupButton" :title="uploadPopupTitle"
            :active.sync="filesPopup">
            <vs-row>
                <vs-col vs-offset="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <label for="files_input"
                        class="files_input_button vs-component vs-button vs-button-primary vs-button-filled includeIcon">
                        <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-upload null"
                            style="order: 0; margin-right: 5px; margin-left: 0px;"></i>
                        <span class="vs-button-text vs-button--text">{{$t('select_file')}}</span>
                    </label>
                    <input type="file" id="files_input" class="files_input" :accept="this.accept" multiple ref="files"
                        v-on:change="handleFileUpload()" />
                </vs-col>
            </vs-row>
        </vs-popup>
    </div>
</template>

<script>
    const newsModel = {
        is_important: false,
        title: "",
        content: "",
        files: [],
        addressees: [],
        roles: [],
        courses: [],
        prep_levels: [],
        faculties: [],
        cathedras: [],
        image: '',
        education_programs: [],
        groups: []
    }

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import {
        Quill,
        quillEditor
    } from 'vue-quill-editor'
    import {
        HtmlEditor,
        DocumentBlot,
        AudioBlot
    } from '@/configs/QuiilSetting'
    import {
        mapGetters,
        mapState,
        mapActions
    } from "vuex"
    import vSelect from 'vue-select'

    Quill.register(AudioBlot)
    Quill.register(DocumentBlot)
    Quill.register('modules/htmlEditor', HtmlEditor)

    export default {
        data() {
            return {
                submitHandler: 'news_columnist/postNews',
                textTest: '',
                disabled: false,
                addButtonText: this.$t('add'),
                popupTitle: this.$t('add_news'),
                finalyMessage: this.$t('news_created'),
                isLoading: {
                    prep_levels: false,
                    faculties: false,
                    cathedras: false,
                    education_programs: false,
                    groups: false,
                    roles: false,
                    courses: false,
                    specialist: false
                },
                filesPopup: false,
                files: [],
                uploadType: 'image',
                uploadPopupTitle: '',
                uploadPopupButton: false,
                accept: '',
                deleteUid: '',
                editorOption: {
                    modules: {
                        toolbar: '#toolbar',
                        htmlEditor: true
                    },
                    placeholder: this.$t('enter_text')
                },
                selectActiveProfile: [],
                selectActive: {
                    prep_levels: [],
                    faculties: [],
                    cathedras: [],
                    education_programs: [],
                    groups: [],
                    courses: [],
                    roles: [],
                    specialist: null
                },
                news: Object.assign({}, newsModel)
            }
        },
        computed: {
            ...mapState({
                courses: state => state.news_columnist.courses,
                prep_levels: state => state.news_columnist.prep_levels,
                faculties: state => state.news_columnist.faculties,
                cathedras: state => state.news_columnist.cathedras,
                education_programs: state => state.news_columnist.education_programs,
                groups: state => state.news_columnist.groups,
                roles: state => state.news_columnist.roles,
                uploadSettings: state => state.news_columnist.formSetting,
                currentNews: state => state.news_columnist.currentNews,
                redirectPage: state => state.news_columnist.redirectPage,
                specialist: state => state.news_columnist.specialist,
                user: state => state.user.user
            }),
            modalType() {
                // Проверяем с какого роута вызвана модалка что бы показывать либо создание либо редактирование
                if (this.$route.name === 'detailNews') return false
                else return true
            },
            editor() {
                return this.$refs.contentEditor.quill
            },
            newsPopup: {
                get() {
                    return this.$store.state.news_columnist.newsPopup
                },
                set(val) {
                    this.$validator.pause()
                    this.$store.commit('news_columnist/SET_NEWS_POPUP', val)
                }
            },
            deletePopup: {
                get() {
                    return this.$store.state.news_columnist.deletePopup
                },
                set(val) {
                    this.$store.commit('news_columnist/SET_DELETE_POPUP', val)
                }
            }
        },
        watch: {
            deletePopup(val) {
                if (val && this.currentNews)
                    this.deleteUid = this.currentNews.uid
                else
                    this.deleteUid = ''
            },
            newsPopup(val) {
                if (val) {
                    if (this.currentNews) {
                        // Подставляем данные для редактирование если в currentNews они есть
                        this.news = JSON.parse(JSON.stringify(this.currentNews))
                        this.submitHandler = 'news_columnist/putNews'
                        this.finalyMessage = this.$t('news_updated')
                        this.addButtonText = this.$t('update')
                        this.popupTitle = this.$t('refresh_news')
                        this.updateFormParams()

                        if (this.news.front_image) {
                            // Вставляем изображение в форму загрузки
                            const find = this.files.find(file => file.uid === this.news.front_image.uid)
                            if (!find) {
                                this.files.push({
                                    ...this.news.front_image,
                                    firstFile: true,
                                    response: this.news.front_image
                                })
                            }
                        }
                    }
                } else {
                    this.$nextTick(() => {
                        // Чистить валидатор при закрытии
                        this.$validator.errors.clear()
                        this.$validator.fields.items.forEach(field => field.reset())
                        this.$validator.fields.items.forEach(field => this.errors.remove(field))
                        this.$validator.resume()
                    })
                    // Чистим форму при закрытии
                    this.formClear()
                }
            }
        },
        created: function () {
            if (this.user && !this.user.role.is_specialist) {
                // Если пользователь не специалист, удаляем поле выбора специалиста
                delete this.selectActive.specialist
            }

            // Получаем от сервера настройки формы
            this.$store.dispatch('news_columnist/fetchFormSetting')
        },
        components: {
            quillEditor,
            vSelect
        },
        methods: {
            async deleteNews() {
                // Удалем открытую новость
                try {
                    this.$vs.loading()
                    await this.$http.delete(`/portal/news/${ this.deleteUid }/`)
                } catch (e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close()
                    this.deletePopup = false

                    if (this.redirectPage)
                        this.$router.push({
                            name: this.redirectPage
                        })
                }
            },
            multiselectHander(selectedOption, id) {
                // Получаем список uid выбранных полей
                const getUids = () => {
                    let uids = []
                    if (this.selectActive[id].length) {
                        this.selectActive[id].forEach(item => {
                            uids.push(item.uid)
                        })
                    }
                    return uids
                }

                // Если выбрано факультет или кафедра, обновляем завясящие от них селекты
                if (id === 'faculties') {
                    setTimeout(() => {
                        this.$store.commit('news_columnist/SET_ACTIVE', {
                            key: id,
                            value: getUids(),
                            update_key: ['cathedras', 'groups']
                        })
                    }, 100);
                }
                if (id === 'cathedras') {
                    setTimeout(() => {
                        this.$store.commit('news_columnist/SET_ACTIVE', {
                            key: id,
                            value: getUids(),
                            update_key: ['groups']
                        })
                    }, 100);
                }
            },
            multiselectLabel(item) {
                // Заменяем лэйбл для поиска в селекте
                if (item.name) return item.name
                else if (item.specialist_type) return item.specialist_type.name
                else {
                    if (!isNaN(item)) return item
                    else return this.$t(item)
                }
            },
            async removeFile({
                file,
                done
            }) {
                this.files = await this.files.filter(
                    (item) => item.response.uid !== file.response.uid
                );
                done();
            },
            setFiles(response) {
                // console.log('response', response)
                if (!this.files) this.files = [];
                // Преверяю, на то, чтобы, может прийти ответ с уже записанным в files файл
                if (
                    this.files.indexOf(
                        (item) => item.name === response[0].name
                    )
                ) {
                    const firstFiles = this.files.filter(
                        (item) => item.firstFile || item.name !== response[0].name
                    );
                    const newFiles = response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    });
                    this.files = firstFiles.concat(newFiles);
                } else {
                    this.files = this.files.concat(
                        response.map((item) => {
                            return {
                                ...item,
                                response: item,
                            };
                        })
                    );
                }
            },
            async updateFormParams() {
                // Получаем данные для выпадающих полей при редактировании

                const updateActive = (storeParams, key) => {
                    let params = []
                    this.news[key].forEach(item => {
                        params.push(storeParams[key].find(find => {
                            if (find.uid) return find.uid === item
                            else return find === item
                        }))
                        this.selectActive[key] = params
                    })
                }

                // В цикле подставляем настройки видимости новости
                const storeParams = this.$store.state.news_columnist
                for (let key in this.selectActive) {
                    if (key !== 'specialist') {
                        if (this.news[key].length) {
                            if (!storeParams[key].length) {
                                await this.openSelect(key)
                                updateActive(storeParams, key)
                            } else {
                                updateActive(storeParams, key)
                            }
                        }
                    }
                }

                // Если юзер специалист, и в новости есть ключ object_id, подставляем его в нужное значение
                if (this.user && this.user.role.is_specialist) {
                    if (this.news.object_id) {
                        let params = null
                        if (!storeParams['specialist'].length) {
                            await this.openSelect('specialist')
                            params = storeParams['specialist'].find(item => item.uid === this.news.object_id)
                            this.selectActive['specialist'] = params
                        } else {
                            params = storeParams['specialist'].find(item => item.uid === this.news.object_id)
                            this.selectActive['specialist'] = params
                        }
                    }
                }
            },
            formClear() {
                // Очищаем форму новости
                this.news = Object.assign({}, newsModel)

                for (let key in this.selectActive) {
                    if (key !== 'specialist')
                        this.selectActive[key] = []
                    else
                        this.selectActive[key] = null
                }

                this.$refs['imageUpload'].removeFile(0)

                this.selectActiveProfile = []
                this.files = []
            },
            dynamicOptions(name) {
                // Так как поле настроек видимости выводиться в цикле, через эту функцию подставляем нужные данные в поле
                switch (name) {
                    case 'prep_levels':
                        return this.prep_levels
                        break;
                    case 'faculties':
                        return this.faculties
                        break;
                    case 'cathedras':
                        return this.cathedras
                        break;
                    case 'education_programs':
                        return this.education_programs
                        break;
                    case 'groups':
                        return this.groups
                        break;
                    case 'roles':
                        return this.roles
                        break;
                    case 'courses':
                        return this.courses
                        break;
                    case 'specialist':
                        return this.specialist
                        break;
                }
            },
            async formSubmit({is_close_modal = true}) {


                // Валидация формы перед отправкой
                this.$validator.validateAll().then(async result => {
                    if (result) {

                        if (this.user && this.user.role.is_specialist && !this.selectActive[
                                'specialist']) {
                            this.$vs.notify({
                                text: this.$t('select_specialist_type'),
                                color: 'warning'
                            })
                            return false
                        }

                        if (this.selectActiveProfile.length) {
                            let addressees = []
                            this.selectActiveProfile.forEach(item => {
                                addressees.push(item.uid)
                            })
                            this.news['addressees'] = addressees
                        }

                        // Заполняем настройки видимости для новости
                        for (let key in this.selectActive) {
                            if (key === 'specialist') {
                                if (this.selectActive[key])
                                    this.news['object_id'] = this.selectActive[key].uid
                            } else {
                                if (this.selectActive[key].length) {
                                    let newArray = []

                                    this.selectActive[key].forEach(item => {
                                        if (item.uid) newArray.push(item.uid)
                                        else newArray.push(item)
                                    })

                                    this.news[key] = newArray
                                } else {
                                    this.news[key] = []
                                }
                            }
                        }

                        // Если есть изображение получаем ее uid
                        if (this.files.length)
                            this.news.image = this.files[0].uid
                        else
                            this.news.image = ''

                        try {
                            this.disabled = true
                            this.$vs.loading()

                            // Заполняем объект новости перед отправкой
                            let payload = {
                                body: this.news
                            }

                            // Если мы редактируем новость то получаем ее uid из адреса
                            if (this.currentNews)
                                payload['uid'] = this.currentNews.uid

                            // Если это специалист, добавляем информацию об этом в тело
                            if (this.user && this.user.role.is_specialist) {
                                payload.body['is_specialist'] = true
                            }

                            // Отправляем запрос на создание/обновление новости
                            await this.$store.dispatch(this.submitHandler, payload)
                            this.$vs.notify({
                                text: this.finalyMessage,
                                color: 'success'
                            })

                            // Если это обновление, перезагружаем страницу
                            if (this.currentNews) {
                                this.newsPopup = false
                                this.$router.go(this.$router.currentRoute)
                            } else {
                                this.$validator.reset()
                            }
                            this.formClear()
                        } catch (error) {
                            this.$vs.notify({
                                text: error,
                                color: 'danger'
                            })
                        } finally {
                            this.disabled = false
                            this.$vs.loading.close();
                            this.newsPopup = is_close_modal;
                            this.$store.commit('news_columnist/SET_RELOAD_PAGE', true)

                        }
                    }
                })
            },

            filesModalHandler(type) {
                // Quill
                // Подставляем нужные настройки при выборе типа загрузки файла
                switch (type) {
                    case 'image':
                        this.uploadPopupTitle = this.$t('upload_image')
                        this.uploadType = 'image'
                        this.accept = ".jpg, .jpeg, .png, .gif"
                        break;
                    case 'video':
                        this.uploadPopupTitle = this.$t('upload_video')
                        this.uploadType = 'video'
                        this.accept = "video/*"
                        break;
                    case 'audio':
                        this.uploadPopupTitle = this.$t('upload_audio')
                        this.uploadType = 'audio'
                        this.accept = "audio/*"
                        break;
                    case 'doc':
                        this.uploadPopupTitle = this.$t('upload_document')
                        this.uploadType = 'doc'
                        this.accept = ".doc, .docx, .xlsx, .xls, .pdf"
                        break;
                }
                this.filesPopup = true
            },
            async handleFileUpload() {
                // Получаем файлы от поля загрузки
                const files = this.$refs.files.files;

                // Проверяем выбранное количество файлов для загрузки, если больше 5 то отменяем загрузку и выводм сообщение
                if (files.length > 5) {
                    this.$vs.notify({
                        text: `За один раз можно загрузить максимум 5 файлов`,
                        color: 'warning'
                    })
                }

                // Заполняем formData перед загрузкой файлов
                let formData = new FormData();
                for (var i = 0; i < files.length; i++) {
                    // Проверяем размер файла, если превышает выводим сообщение
                    let maxFileSize = this.uploadSettings.max_file_size

                    // Если это видео, ставим макс размер файла на 100 мб
                    if (this.uploadType === 'video') maxFileSize = 100

                    // Если это аудио, ставим макс размер файла на 50 мб
                    if (this.uploadType === 'audio') maxFileSize = 50

                    if (this.uploadSettings.max_file_size && ((files[i].size / 1024) / 1024) >= maxFileSize) {
                        this.$vs.notify({
                            text: `Файл ${ files[i].name } превышает ${ maxFileSize } мегабайт!`,
                            color: 'warning'
                        })
                        continue;
                    }
                    if (i > 4)
                        continue;
                    formData.append('path', files[i]);
                }

                // Если formData не пустая то продолжаем отправку
                if (formData.has('path')) {
                    try {
                        this.$vs.loading({
                            background: 'primary',
                            color: '#fff',
                            container: '.files_input_button',
                            scale: 0.45
                        })
                        this.uploadPopupButton = true

                        // Загружаем файлы на сервер
                        const {
                            data
                        } = await this.$http.post('common/upload/', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })

                        // Фокусируемся на quill для вставки файла
                        this.editor.focus()
                        let length = this.editor.getSelection().index;

                        // В цикле вставляем файлы в поле quill
                        data.forEach(file => {
                            if (this.uploadType === 'doc') this.editor.insertEmbed(length, this.uploadType,
                                file)
                            else this.editor.insertEmbed(length, this.uploadType, file.path)
                        })

                        this.filesPopup = false
                        this.$vs.notify({
                            text: 'Файл добавлен',
                            color: 'success'
                        })
                    } catch (error) {
                        this.$vs.notify({
                            text: error,
                            color: 'danger'
                        })
                    } finally {
                        this.$vs.loading.close('.files_input_button > .con-vs-loading')
                        this.uploadPopupButton = false
                    }
                }
            },
            async openSelect(type) {
                // События открытия выпадающего списка, при открытии либо запрашиваем данные для поля с сервера, либо получаем со стора ранее запрошенные данные
                try {
                    // Включаем у селекта индикатор загрузки
                    this.isLoading[type] = true
                    const res = await this.$store.dispatch('news_columnist/checkSelectType', type)

                    if (type === 'specialist' && res.length === 1)
                        this.selectActive['specialist'] = res[0]
                } catch (e) {
                    this.$vs.notify({
                        text: e,
                        color: 'danger'
                    })
                } finally {
                    // Отключаем у селекта индикатор загрузки
                    this.isLoading[type] = false
                }
            }
        }
    }

</script>

<style lang="scss">

    ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(var(--vs-primary), 1) !important;
    }
    ::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    .zindex {
        z-index: 0;
    }

    .delete_btn {
        position: relative;

        .con-vs-loading {
            position: absolute;
        }
    }

    .ql-tooltip {
        &.ql-editing {
            &[data-mode="video"] {
                left: 10px !important;
                z-index: 50;
            }
        }
    }

    .news_delete_modal {
        .vs-popup {
            width: 400px !important;
        }
    }

    .news_modal {
        .vs-popup {
            width: 960px !important;
        }

        .quill-editor {
            .vs-icon {
                font-size: 18px;
            }

            #toolbar {
                position: sticky;
                top: -15px;
                z-index: 5555;
                background: #ffffff;
            }

            .ql-edit-html-textarea {
                width: 100%;
                background: rgb(29, 29, 29);
                color: rgb(204, 204, 204);
                outline: none;
                padding: 12px 15px;
                font-family: Consolas;
                position: absolute;
                top: 0;
                bottom: 0;
                border: none;
            }
        }
    }

    .upload_popup {
        z-index: 54000;

        .files_input {
            display: none;
        }

        .vs-popup {
            width: 400px !important;
        }

        .files_input_button {
            position: relative;
            overflow: hidden;

            .con-vs-loading {
                position: absolute;
            }
        }
    }

    .collapse_margin {
        background: #f8f8f8;

        .open-item {
            .vs-collapse-item--content {
                overflow: initial !important;
                max-height: initial !important;
            }
        }
    }

</style>
